import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d9204f9c&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=d9204f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9204f9c",
  null
  
)

export default component.exports